/*********************
Score Pass 1: Ready Score / Occurrence Count

This score pass modifies static variables for each intervention type
*********************/
import {
  interventionTypes,
  interventionSituationTypes,
  disabledInterventionTypes,
  interventionDefaultReadyScores,
  interventionClasses,
} from '../../constants';

export default function getReadyScoresForRun(state, PASS_CONFIGS) {
  const {
    READY_wordLevelDelta, // interventions accumulate value, when not selected/played at the word level
    READY_phraseLevelDelta, // interventions accumulate value, when not selected/played at the the phrase level
    READY_interventionUsedDelta, // interventions deccumulate value, when played by the app
  } = PASS_CONFIGS.scorePass1;

  // initialize ready scores
  let readyScores = {};
  let occurrenceCounts = {};
  let recentOccurrenceCounts = {};
  let relativeRecentOccurrenceCounts = {};
  Object.keys(interventionTypes).forEach(key => {
    if(!disabledInterventionTypes[key]) {
      if(interventionDefaultReadyScores[key]) {
        readyScores[key] = interventionDefaultReadyScores[key];
      } else {
        readyScores[key] = 0;
      }
      occurrenceCounts[key] = 0;
      recentOccurrenceCounts[key] = 0;
      relativeRecentOccurrenceCounts[key] = 0;
    }
  });

  // Go through the activity history, incrementing and decrementing ready scores
  let isReadWithMeMode = false;
  let lastFourInterventions = [];

  state.interventionHistoryByPhrase.forEach((phraseInterventions, index) => {
    let mostRecentPhrase = false;
    if(index == (state.interventionHistoryByPhrase.length - 1)) {
      mostRecentPhrase = true;
    }
    phraseInterventions.forEach(intervention => {
      if(intervention.type != interventionTypes.none){
        if(lastFourInterventions.length >= 4){
          lastFourInterventions.shift();
        }
        lastFourInterventions.push(intervention.type);
      }
      if(intervention.type == interventionTypes.initiateReadWithMe) {
        isReadWithMeMode = true;
      }
      Object.keys(interventionTypes).forEach(key => {
        let classKeys = [key];
        if(interventionClasses[key]) {
          classKeys = interventionClasses[key];
        }
        if(classKeys.includes(intervention.type)) {
          readyScores[key] += READY_interventionUsedDelta;
          occurrenceCounts[key] += 1;
          if(mostRecentPhrase) {
            recentOccurrenceCounts[key] += 1;
          }
        } else if(intervention.situation == interventionSituationTypes.PHRASE) {
          readyScores[key] += READY_phraseLevelDelta;
        } else if(intervention.situation == interventionSituationTypes.WORD) {
          readyScores[key] += READY_wordLevelDelta;
        }
      });
    });
  });

  //after we have finished the above iteration, check the relative recency count of each intervention type in one more loop
  lastFourInterventions.forEach(interventionType => {
    Object.keys(interventionTypes).forEach(key => {
      let classKeys = [key];
      if(interventionClasses[key]) {
        classKeys = interventionClasses[key];
      }
      if(classKeys.includes(interventionType)) {
        relativeRecentOccurrenceCounts[key] += 1;
      }
    });
  });

  state.scores.ready = readyScores;
  state.scores.occurrenceCounts = occurrenceCounts;
  state.scores.recentOccurrenceCounts = recentOccurrenceCounts;
  state.scores.relativeRecentOccurrenceCounts = relativeRecentOccurrenceCounts;
  state.isReadWithMeMode = isReadWithMeMode;
}